import styled from "styled-components";

export const MobileSearchSection = styled.div<{ isDarkMode?: any }>`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    background-color: ${({theme}) => theme.body};
    width: 100%;
`;
export const MobileHeaderSearch = styled.div`
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 20px;
`;
export const SearchInput = styled.div`
    flex: 1;
    width: 100%;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;

    &.inputWithIcon {
        position: relative;
    }

    .left-icon {
        position: absolute;
        left: 10px;
        top: 37%;
        transform: translateY(-37%);
    }

    .right-icon {
        width: 15px;
        height: 15px;
        position: absolute;
        right: 10px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 37%;
        padding-bottom: 1px;
        padding-right: 0px;
        transform: translateY(-37%);
        background-color: ${(p) => p.theme.COLORS.borderColor};
        border-radius: 50px;
    }
`;
